/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const OLMES = ({ color = 'primary', aspectRatio = '780/133', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="OLMES" aspectRatio={aspectRatio} color={color} {...rest} />;

export { OLMES, OLMES as default };
